module.exports = __webpack_public_path__ + "static/media/legende_construction_white.92ccebe9.svg";